module.exports = __webpack_public_path__ + "img/情商@2x.48018a8f.png";